import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../../actions/products';
import Products from './Products';

const mapStateToProps = (state) => {
  return {
    loading: state.products.get('loading'),
    error: state.products.get('error'),
    products: state.products.get('data')
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    actions,
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);



// WEBPACK FOOTER //
// ./src/app/components/Views/Products/index.js